import { bootstrapWidget } from "../../common";
import PropertyTitleWidget from "./widget";

bootstrapWidget({ widget: PropertyTitleWidget, widgetType: "property-title" });
